




































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import DeleteButton from "@/components/datatable/DeleteButton.vue";
import Id from "@/components/inputs/Id.vue";
import EForm from "@/components/datatable/EForm.vue";
import TextField from "@/components/inputs/TextField.vue";
import Dates from "@/components/inputs/dates.vue";
import Decimal from "@/components/inputs/Decimal.vue";
import { store } from "@/store";
import Select61 from "@/components/inputs/Select61.vue";
import FaizOranTopluEkle from "@/components/icraproWeb/FaizOranTopluEkle.vue";

class Faiz {
  id!: number;
  tarih!: Date;
  oran_aylik_mi!: boolean;
  uygulandi_mi!: boolean;
  aylik_oran!: number;
  yillik_oran!: number;
  faiz_turu_id!: number;
  uyap_tip_kod!: number | null;
  uyap_genel_kod!: number | null;
  created_at!: string | null;
  updated_at!: string | null;
  deleted_at!: string | null;
  islem_turu!: string | null;
  faiz_turu_adi!: string;
}

class FaizTuru {
  id!: number;
  isim!: string;
  standart_mi!: boolean;
  yillik_devreyle_islesin_mi!: boolean;
  uyap_kod!: string;
  uyap_aciklama!: string;
  aktif_mi!: boolean;
  uygulandi_mi!: boolean;
  created_at!: string | null;
  updated_at!: string | null;
  deleted_at!: string | null;
  islem_turu!: string | null;
}

@Component({
  computed: {
    store() {
      return store;
    }
  },
  components: { Select61, Decimal, Dates, TextField, EForm, Id, DeleteButton, FaizOranTopluEkle }
})
export default class Faizler extends Vue {
  topluEkleDialog: boolean = false;
  ornekIndiriliyor: boolean = false;
  faizDialog: boolean = false;
  faizAction: string = this.$store.state.icwApiUrl + 'admin/faiz-oran';
  faizData = new Faiz();
  faizTitle: string = "";
  faizlerLoading: boolean = true;
  faizlerHeaders = [
    { text: "Id", value: "id" },
    { text: "Tarih", value: "tarih" },
    { text: "Oran Aylık Mı", value: "oran_aylik_mi" },
    { text: "Aylık Oran", value: "aylik_oran" },
    { text: "Yıllık Oran", value: "yillik_oran" },
    { text: "Faiz Türü", value: "faiz_turu_adi" },
    { text: "Uyap Tip Kod", value: "uyap_tip_kod" },
    { text: "Uyap Genel Kod", value: "uyap_genel_kod" },
    { text: "İşlemler", value: "actions", align: "right" }
  ];
  faizler: Faiz[] = [];
  faizSearch: string = "";

  faizTuruDialog: boolean = false;
  faizTuruAction: string = this.$store.state.icwApiUrl + 'admin/faiz-turu';
  faizTuruData = new FaizTuru();
  faizTuruTitle: string = "";
  faizTurleriLoading: boolean = true;
  faizTurleriHeaders = [
    { text: "Id", value: "id" },
    { text: "İsim", value: "isim" },
    { text: "Standart Mı", value: "standart_mi" },
    { text: "Yıllık Devreyle İşlesin Mi", value: "yillik_devreyle_islesin_mi" },
    { text: "Uyap Kod", value: "uyap_kod" },
    { text: "Uyap Açıklama", value: "uyap_aciklama" },
    { text: "Aktif Mi", value: "aktif_mi" },
    { text: "İşlemler", value: "actions", align: "right" }
  ];
  faizTurleri: FaizTuru[] = [];
  faizTuruSearch: string = "";


  get uygulanmamisFaizTuruSayisi(): number {
    return this.faizTurleri.filter((faizTuru: FaizTuru) => !faizTuru.uygulandi_mi).length;
  }

  updatingRate: boolean = false;

  mounted() {
    this.loadFaizler();
    this.loadFaizTurleri();
  }

  async loadFaizler() {
    try {
      this.faizlerLoading = true;
      this.faizler = (await this.$http.get(this.$store.state.icwApiUrl + 'admin/faiz-oranlari')).data;
    } catch (e) {
      console.error('HATA ---: ', e);
    } finally {
      this.faizlerLoading = false;
    }
  }

  async loadFaizTurleri() {
    try {
      this.faizTurleriLoading = true;
      this.faizTurleri = (await this.$http.get(this.$store.state.icwApiUrl + 'admin/faiz-turleri')).data;
    } catch (e) {
      console.error('HATA ---: ', e);
    } finally {
      this.faizTurleriLoading = false;
    }
  }

  editFaiz(item: Faiz) {
    this.faizTitle = "Düzenle";
    // Liste bu alanı 0/1 döndürür, seçenekler ise true/false ile eşleşir;
    // dönüştürülmezse "Oran Aylık Mı" hiçbir seçenek işaretli gelmez.
    item.oran_aylik_mi = !!Number(item.oran_aylik_mi);
    this.faizData = item;
    this.faizAction = this.$store.state.icwApiUrl + 'admin/faiz-oran/' + item.id;
    this.faizDialog = true;
  }

  addFaiz() {
    this.faizTitle = "Ekle";
    this.faizData = new Faiz();
    this.faizAction = this.$store.state.icwApiUrl + 'admin/faiz-oran';
    this.faizDialog = true;
  }

  editFaizTuru(item: FaizTuru) {
    this.faizTuruTitle = "Düzenle";
    this.faizTuruData = item;
    this.faizTuruAction = this.$store.state.icwApiUrl + 'admin/faiz-turu/' + item.id;
    this.faizTuruDialog = true;
  }

  addFaizTuru() {
    this.faizTuruTitle = "Ekle";
    this.faizTuruData = new FaizTuru();
    this.faizTuruData.aktif_mi = true;
    this.faizTuruAction = this.$store.state.icwApiUrl + 'admin/faiz-turu';
    this.faizTuruDialog = true;
  }

  // DEV-3842: "Uygula" düğmesi kaldırıldı. Faiz oranları ortak tablodan
  // okunuyor; kaydedilen oran bütün bürolar için hemen geçerli, ayrıca
  // uygulanacak bir şey yok.

  async ornekExcelIndir() {
    if (this.ornekIndiriliyor) return;
    this.ornekIndiriliyor = true;

    try {
      await (this.$refs.topluEkle as any).ornekIndir();
    } finally {
      this.ornekIndiriliyor = false;
    }
  }

  /*  async uygulaFaizTuru() {
      try {
        await this.$http.post(this.$store.state.icwApiUrl + 'admin/panel-uygula-buton/faiz_turu', {
          islem_turu: UygulaIslemTuru.GUNCELLE
        });
        this.$toast.success('Faiz türleri başarıyla uygulandı.');
      } catch (e) {
        console.error('HATA ---: ', e);
        this.$toast.error('Faiz türlerini uygularken hata oluştu. (' + e.message + ')');
      } finally {
        await this.loadFaizTurleri();
      }
    }*/

  @Watch('faizData.aylik_oran')
  onAylikOranChange(newVal: number) {
    if (this.updatingRate) return;
    if (this.faizData.oran_aylik_mi) {
      this.updatingRate = true;
      this.faizData.yillik_oran = newVal ? newVal * 12 : 0;
      this.updatingRate = false;
    }
  }

  @Watch('faizData.yillik_oran')
  onYillikOranChange(newVal: number) {
    if (this.updatingRate) return;
    if (!this.faizData.oran_aylik_mi) {
      this.updatingRate = true;
      this.faizData.aylik_oran = newVal ? newVal / 12 : 0;
      this.updatingRate = false;
    }
  }

  @Watch('faizData.oran_aylik_mi')
  onOranAylikMiChange(newVal: boolean, oldVal: boolean) {
    if (newVal === oldVal) return;
    this.updatingRate = true;
    if (newVal) {
      if (this.faizData.yillik_oran) {
        this.faizData.aylik_oran = this.faizData.yillik_oran / 12;
      }
    } else {
      if (this.faizData.aylik_oran) {
        this.faizData.yillik_oran = this.faizData.aylik_oran * 12;
      }
    }
    this.updatingRate = false;
  }

}
